/* eslint-disable react/prop-types */
/* eslint-disable react/prefer-stateless-function */
import { __ } from '@wordpress/i18n';
import { Component, Fragment } from 'react';

import {
	Panel,
	PanelBody,
	PanelHeader,
	ToggleControl,
} from '@wordpress/components';

import Text from 'Components/Text';
import Label from 'Components/Label';
import TextArea from 'Components/TextArea';
import ThemeSelect, { themeOptions } from 'Components/ThemeSelect';
import {
	getCurrentSelected,
	toggleAttributeBasedOnString,
	getToggleAttributeBoolValueBasedOnString,
	handleTopLevelInput,
} from 'Utils/helpers';

class Portal extends Component {
	toggleAttribute = attr => {
		const { attributes, setAttributes } = this.props;
		toggleAttributeBasedOnString(attr, attributes, setAttributes);
	};

	getToogleAttrBoolValue = attr => {
		const { attributes } = this.props;
		return getToggleAttributeBoolValueBasedOnString(attr, attributes);
	};

	handleTopLevelInput = e => {
		const { setAttributes } = this.props;
		handleTopLevelInput(e, setAttributes);
	};

	render() {
		const { attributes, setAttributes } = this.props;
		return (
			<div>
				<Panel>
					<PanelHeader>
						{__('LOGIN PAGE MODIFICATIONS', 'ipt_fsqm')}
					</PanelHeader>
					<PanelBody>
						<Label
							title={__(
								'Message shown to logged out users',
								'ipt_fsqm'
							)}
						>
							<Text
								value={attributes.login}
								name="login"
								onChange={this.handleTopLevelInput}
							/>
						</Label>
						<Label title={__('Control Buttons', 'ipt_fsqm')}>
							<Fragment>
								<ToggleControl
									label={__(
										'Show registration button',
										'ipt_fsqm'
									)}
									checked={this.getToogleAttrBoolValue(
										'show_register'
									)}
									onChange={() => {
										this.toggleAttribute('show_register');
									}}
								/>
								<ToggleControl
									label={__(
										'Show password reset button',
										'ipt_fsqm'
									)}
									checked={this.getToogleAttrBoolValue(
										'show_forgot'
									)}
									onChange={() => {
										this.toggleAttribute('show_forgot');
									}}
								/>
							</Fragment>
						</Label>
					</PanelBody>
				</Panel>
				<Panel>
					<PanelHeader>
						{__('PORTAL PAGE MODIFICATION', 'ipt_fsqm')}
					</PanelHeader>
					<PanelBody>
						<Label title={__('Welcome Title', 'ipt_fsqm')}>
							<Text
								value={attributes.title}
								name="title"
								onChange={this.handleTopLevelInput}
							/>
						</Label>
						<Label title={__('Welcome Message', 'ipt_fsqm')}>
							<TextArea
								value={attributes.content}
								name="content"
								onChange={this.handleTopLevelInput}
							/>
						</Label>
						<Label
							title={__(
								'Message shown if there are no submissions',
								'ipt_fsqm'
							)}
						>
							<Text
								value={attributes.nosubmission}
								name="nosubmission"
								onChange={this.handleTopLevelInput}
							/>
						</Label>
						<Label title={__('Form heading label', 'ipt_fsqm')}>
							<Text
								value={attributes.formlabel}
								name="formlabel"
								onChange={this.handleTopLevelInput}
							/>
						</Label>
						<Label title={__('COLUMNS SELECTION', 'ipt_fsqm')}>
							<Fragment>
								<ToggleControl
									label={__(
										'Show filters for Forms and Categories',
										'ipt_fsqm'
									)}
									checked={this.getToogleAttrBoolValue(
										'filters'
									)}
									onChange={() => {
										this.toggleAttribute('filters');
									}}
								/>
								<ToggleControl
									label={__(
										'Show Category column',
										'ipt_fsqm'
									)}
									checked={this.getToogleAttrBoolValue(
										'showcategory'
									)}
									onChange={() => {
										this.toggleAttribute('showcategory');
									}}
								/>
								<ToggleControl
									label={__('Show Score column', 'ipt_fsqm')}
									checked={this.getToogleAttrBoolValue(
										'showscore'
									)}
									onChange={() => {
										this.toggleAttribute('showscore');
									}}
								/>
								<ToggleControl
									label={__(
										'Show Admin Remarks column',
										'ipt_fsqm'
									)}
									checked={this.getToogleAttrBoolValue(
										'showremarks'
									)}
									onChange={() => {
										this.toggleAttribute('showremarks');
									}}
								/>
							</Fragment>
						</Label>
						<Label title={__('Date column label', 'ipt_fsqm')}>
							<Text
								value={attributes.datelabel}
								name="datelabel"
								onChange={this.handleTopLevelInput}
							/>
						</Label>
						{this.getToogleAttrBoolValue('showcategory') ? (
							<Label
								title={__('Category column label', 'ipt_fsqm')}
							>
								<Text
									value={attributes.categorylabel}
									name="categorylabel"
									onChange={this.handleTopLevelInput}
								/>
							</Label>
						) : null}
						{this.getToogleAttrBoolValue('showscore') ? (
							<Fragment>
								<Label
									title={__('Score column label', 'ipt_fsqm')}
								>
									<Text
										value={attributes.scorelabel}
										name="scorelabel"
										onChange={this.handleTopLevelInput}
									/>
								</Label>
								<Label
									title={__(
										'Max Score column label',
										'ipt_fsqm'
									)}
								>
									<Text
										value={attributes.mscorelabel}
										name="mscorelabel"
										onChange={this.handleTopLevelInput}
									/>
								</Label>
								<Label
									title={__(
										'Percentage Score column label',
										'ipt_fsqm'
									)}
								>
									<Text
										value={attributes.pscorelabel}
										name="pscorelabel"
										onChange={this.handleTopLevelInput}
									/>
								</Label>
							</Fragment>
						) : null}
						{this.getToogleAttrBoolValue('showremarks') ? (
							<Fragment>
								<Label
									title={__(
										'Admin Remarks column label',
										'ipt_fsqm'
									)}
								>
									<Text
										value={attributes.remarkslabel}
										name="remarkslabel"
										onChange={this.handleTopLevelInput}
									/>
								</Label>
							</Fragment>
						) : null}
						<Label title={__('Action column label', 'ipt_fsqm')}>
							<Text
								value={attributes.actionlabel}
								name="actionlabel"
								onChange={this.handleTopLevelInput}
							/>
						</Label>
						<Label title={__('Track button label', 'ipt_fsqm')}>
							<Text
								value={attributes.linklabel}
								name="linklabel"
								onChange={this.handleTopLevelInput}
							/>
						</Label>
						<Label title={__('Edit button label', 'ipt_fsqm')}>
							<Text
								value={attributes.editlabel}
								name="editlabel"
								onChange={this.handleTopLevelInput}
							/>
						</Label>
						<Label title={__('Avatar Size', 'ipt_fsqm')}>
							<Text
								value={attributes.avatar}
								type="number"
								min="0"
								name="avatar"
								onChange={this.handleTopLevelInput}
							/>
						</Label>
						<ThemeSelect
							value={getCurrentSelected(
								themeOptions,
								attributes.theme
							)}
							onChange={e => {
								setAttributes({ theme: e.value });
							}}
						/>
						<Label
							title={__(
								'Redirect to URL after logout',
								'ipt_fsqm'
							)}
						>
							<Text
								value={attributes.logout_r}
								min="0"
								name="logout_r"
								placeholder={__(
									'keep empty to disable',
									'ipt_fsqm'
								)}
								onChange={this.handleTopLevelInput}
							/>
						</Label>
					</PanelBody>
				</Panel>
			</div>
		);
	}
}

export default Portal;
